import type { IApiErrorResponseBody } from './ApiClient';

export class ApiError extends Error {
  public constructor(
    public readonly errors: Array<IApiErrorResponseBody>,
    public readonly context?: object,
  ) {
    const extraErrorCount = errors.length > 1 ? errors.length : undefined;

    super(
      `${errors[0].message}${extraErrorCount ? ` (+${extraErrorCount} more)` : ''}`,
    );
  }
}
